import { string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../../../styles/Styles.variables";

import FilestackAdaptive from "../../filestack-adaptive";

const LocationHero = ({ alt, handle, targetDevice, ...rest }) => {
  return (
    <Hero {...rest}>
      <HeroContainer>
        <HeroImage
          align="bottom"
          alt={alt}
          fit="crop"
          handle={handle}
          sizes={{
            "901px": { height: 150, width: 1280 },
            "769px": { height: 150, width: 900 },
            "481px": { height: 128, width: 768 },
            "0px": { height: 100, width: 480 },
          }}
          theme={targetDevice === "mobile" ? "dark" : "light"}
        />
      </HeroContainer>
    </Hero>
  );
};

LocationHero.propTypes = {
  alt: string,
  handle: string.isRequired,
  targetDevice: string,
};

const Hero = styled.div`
  overflow: hidden;
`;

const HeroContainer = styled.div`
  background-color: ${colors.gray200};
  height: 0;
  overflow: hidden;
  padding-top: 20.833333333%;
  position: relative;

  @media (min-width: ${rem("481px")}) {
    padding-top: 16.666666667%;
  }

  @media (min-width: ${rem("769px")}) {
    padding-top: ${rem("150px")};
  }

  @media (min-width: ${rem("901px")}) {
    padding-top: 11.71875%;
  }
`;

const HeroImage = styled(FilestackAdaptive)`
  bottom: 0;
  display: block;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  overflow: hidden;
  position: absolute;
  right: 0%;
  top: 0;
  width: 100%;

  img {
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0%;
    top: 0;
    width: 100%;
  }
`;

export default LocationHero;
